import { TOOLTIP_RESERVED_HEIGHT } from '../utils';

const BARS = [10, 20, 50, 60, 100, 90, 20, 70, 60, 30];

type Props = {
  height?: number;
};

export const FairValueHistogramSkeleton = ({ height = 100 }: Props) => {
  const chartHeight = height - TOOLTIP_RESERVED_HEIGHT - 32;
  return (
    <div className="grid gap-x1">
      <div className="grid grid-cols-1 place-items-center">
        <div
          className="bones w-60"
          style={{ height: TOOLTIP_RESERVED_HEIGHT }}
        />
      </div>
      <div
        className="grid grid-cols-[repeat(10,1fr)] items-end gap-x1"
        style={{ height: chartHeight }}
      >
        {BARS.map((barHeight, index) => (
          <div
            key={index}
            className="bones"
            style={{ height: `${barHeight}%` }}
          />
        ))}
      </div>
      <div className="bones h-x4" />
    </div>
  );
};
